<template>
  <div class="qr-wrapper">
    <VueQrcode id="qrCodeDom" class="qrcode" :value="url" :options="{size:800}" />
    <canvas id="canvas" />
  </div>
</template>

<script>
import VueQrcode from '@xkeshi/vue-qrcode'
import '@utils/baseProto.js'
import wechatImgSrc from '@assets/img/qrcode.jpeg'
import companyQrcodeSrc from '@assets/img/company-qrcode.png'
export default {
  components: {
    VueQrcode
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {
    url () {
      this.createCanvas()
    }
  },
  created () {},
  mounted () {
    this.createCanvas()
  },
  activated () {},
  updated () {},
  methods: {
    /*
    str:要绘制的字符串
    canvas:canvas对象
    initX:绘制字符串起始x坐标
    initY:绘制字符串起始y坐标
    lineHeight:字行高
    */
    canvasTextAutoLine (str, canvas, initX, initY, lineHeight, textWidth) {
      var ctx = canvas.getContext('2d')
      var lineWidth = 0
      // var canvasWidth = canvas.width
      var lastSubStrIndex = 0
      str = str.toString()
      for (let i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width
        let isNextLine = str.substr(i, 1) === '\n'
        // let isLastLine = str.substr(i - 1,2) === '\\n'
        if (lineWidth > textWidth || isNextLine) {
          ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY)
          initY += lineHeight
          lineWidth = 0
          lastSubStrIndex = i
          if (isNextLine) {
            lastSubStrIndex = i + 1
          }
        }
        if (i === str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY)
        }
      }
    },
    createCanvas () {
      const vm = this
      const qrCodeDom = document.getElementById('qrCodeDom')
      const canvas = document.getElementById('canvas')
      canvas.width = 750
      canvas.height = 1334
      // canvas.style.letterSpacing = '20px';
      const dataURL = qrCodeDom.toDataURL('image/png')
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, 750, 1334)
      const img = new Image()
      img.src = dataURL
      const titleImg = new Image()
      titleImg.src = companyQrcodeSrc
      const wechatImg = new Image()
      wechatImg.src = wechatImgSrc
      img.onload = () => {
        titleImg.onload = () => {
          draw()
        }
      }
      function draw () {
        var bg = ctx.createPattern(titleImg, 'repeat')
        ctx.fillStyle = bg
        ctx.fillRect(0, 0, 750, 1334)
        ctx.font = '34px PingFang SC'
        ctx.fillStyle = '#fff'
        ctx.fillText('扫码识别二维码 提交开票抬头', 137, 140)
        ctx.save()
        ctx.restore()

        ctx.fillStyle = '#fff'
        ctx.roundRect(70, 258, 610, 699, 30)
        ctx.fill()
        ctx.drawImage(img, 125, 310, 500, 500)

        ctx.font = '28px PingFang SC'
        ctx.fillStyle = '#333'
        vm.canvasTextAutoLine(vm.name, canvas, 125, 870, 30, 500)
        ctx.save()
        ctx.restore()

        // ctx.fillStyle = '#fff'
        // ctx.roundRect(30, 1100, 690, 199, 12)
        // ctx.fill()

        // ctx.font = '30px iconfont'
        // ctx.fillStyle = '#2372FF'
        // ctx.fillText('\ue614', 160, 1160)
        // ctx.save()
        // ctx.restore()

        // ctx.font = '24px PingFang SC'
        // ctx.fillStyle = '#333'
        // ctx.fillText('慧穗数字科技（上海）有限公司', 75, 1208)

        // ctx.fillStyle = '#FBC636'
        // ctx.roundRect(75, 1240, 205, 30, 15)
        // ctx.fill()

        // ctx.font = '16px PingFang SC'
        // ctx.fillStyle = '#fff'
        // ctx.fillText('扫描二维码，关注公众号', 86, 1260)
        // ctx.drawImage(wechatImg, 543, 1124, 150, 150)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.qr-wrapper{
  display: flex;
  justify-content: center;
  .qrcode{
    display: none;
  }
  #canvas{
    width: 200px;
    // display: none;
  }
}
</style>
